import React from "react";
import "../Styles/Home.css";
import logo from "../assets/logo.png";

const Home = () => {
  return (
    <div className="home-layout">
      <div className="home-left">
        <img src={logo} alt="RCS Logo" className="home-logo" />
      </div>
      <div className="home-right">
        <h2>Welcome to RCS</h2>
        <p>
          Featuring a vast collection of financial services—
          tailored for our customers, agents, partners and investors across Guyana!
          
        </p>

        <div className="nav-info">
        Please use the tabs above to navigate to your destination!
      </div>
      </div>
    </div>
  );
};

export default Home;